import { render, staticRenderFns } from "./ttr-tax-exemption.vue?vue&type=template&id=158f74f0"
import script from "./ttr-tax-exemption.vue?vue&type=script&lang=js"
export * from "./ttr-tax-exemption.vue?vue&type=script&lang=js"
import style0 from "./ttr-tax-exemption.vue?vue&type=style&index=0&id=158f74f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports